import React, { useEffect } from 'react';
import { Star, X, ArrowRight } from 'lucide-react';
import { FeaturedItinerary } from '../../types';

interface Props {
  featuredItineraries: FeaturedItinerary[];
  onUse: (id: number) => void;
  onClose: () => void;
}

const FeaturedModal: React.FC<Props> = ({ featuredItineraries, onUse, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl max-h-[90vh] overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="bg-gradient-to-r from-blue-600 to-cyan-600 text-white p-6">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-3">
              <Star className="w-6 h-6 fill-white" />
              <h2 className="text-2xl font-bold">Featured Templates</h2>
              <span className="text-sm bg-white bg-opacity-20 px-3 py-1 rounded-full">{featuredItineraries.length}</span>
            </div>
            <button onClick={onClose} className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2">
              <X className="w-6 h-6" />
            </button>
          </div>
        </div>

        <div className="p-6 overflow-y-auto max-h-[calc(90vh-100px)]">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {featuredItineraries.map((featured) => (
              <div
                key={featured.id}
                className="group relative bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl p-[2px] hover:shadow-lg transition-all"
              >
                <div className="bg-white rounded-xl p-5 h-full">
                  <div className="flex items-start justify-between mb-3">
                    <h3 className="font-bold text-gray-900 line-clamp-2 flex-1 text-sm">{featured.name}</h3>
                    <Star className="w-4 h-4 text-blue-500 fill-blue-500 flex-shrink-0 ml-2" />
                  </div>
                  
                  <div className="space-y-1 mb-4 text-xs text-gray-600">
                    <p>🌙 {featured.nights} nights • ☀️ {featured.days} days</p>
                    <p>🏨 {featured.hotel_category}</p>
                    {featured.pool_villa && <p>🏊 Pool Villa</p>}
                  </div>
                  
                  <button
                    onClick={() => {
                      onUse(featured.id);
                      onClose();
                    }}
                    className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all flex items-center justify-center gap-2 font-medium text-sm"
                  >
                    Use Template
                    <ArrowRight className="w-4 h-4" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedModal;
